import {atom, DefaultValue, selector} from 'recoil';

const customerNameState = atom({
  key: 'customer_form_name',
  default: '',
});

const customerSystemEmailState = atom({
  key: 'customer_form_system_email',
  default: '',
});

const customerNotesState = atom({
  key: 'customer_form_notes',
  default: '',
});

const customerWarrantyExpirationState = atom({
  key: 'customer_form_warranty_expiration',
  default: '',
});

const customerCodeState = atom({
  key: 'customer_form_code',
  default: '',
});

const customerServiceH24State = atom({
  key: 'customer_form_service_h24',
  default: false,
});

const customerEnabledState = atom({
  key: 'customer_form_enabled',
  default: true,
});
const customerReportEnabledState = atom({
  key: 'customer_form_report_enabled',
  default: true,
});

const customerFormLoadingState = atom({
  key: 'customer_form_loading',
  default: true,
});

const customerFormSavingState = atom({
  key: 'customer_form_saving',
  default: false,
});

const customerFormErrorState = atom({
  key: 'customer_form_Error',
  default: '',
});

const customerFunnelSystemCodeState = atom({
  key: 'customer_form_funnel_system_code',
  default: '',
});

const customerFunnelEmailState = atom({
  key: 'customer_form_funnel_email',
  default: '',
});

const customerSystemTypeState = atom({
  key: 'customer_form_system_type',
  default: '',
});

const customerSystemLinkState = atom({
  key: 'customer_form_system_link',
  default: '',
});

const customerFormState = selector({
  key: 'customerForm',
  get: ({get}) => {
    // get values from individual atoms:
    const code = get(customerCodeState);
    const systemEmail = get(customerSystemEmailState);
    const notes = get(customerNotesState);
    const name = get(customerNameState);
    const warrantyExpiration = get(customerWarrantyExpirationState);
    const serviceH24 = get(customerServiceH24State);
    const saving = get(customerFormSavingState);
    const loading = get(customerFormLoadingState);
    const error = get(customerFormErrorState);
    const funnelSystemCode = get(customerFunnelSystemCodeState);
    const funnelEmail = get(customerFunnelEmailState);
    const systemType = get(customerSystemTypeState);
    const enabled = get(customerEnabledState);
    const reportEnabled = get(customerReportEnabledState);
    const systemLink = get(customerSystemLinkState);
    return {
      name,
      code,
      systemEmail,
      notes,
      warrantyExpiration,
      serviceH24,
      saving,
      loading,
      error,
      funnelSystemCode,
      funnelEmail,
      systemType,
      enabled,
      reportEnabled,
      systemLink
    };
  },
  set: ({set}, value) => {
    if (value instanceof DefaultValue) {
      set(customerCodeState, value);
      set(customerSystemEmailState, value);
      set(customerNotesState, value);
      set(customerNameState, value);
      set(customerWarrantyExpirationState, value);
      set(customerServiceH24State, value);
      set(customerFormSavingState, value);
      set(customerFormErrorState, value);
      set(customerFormLoadingState, value);
      set(customerFunnelSystemCodeState, value);
      set(customerFunnelEmailState, value);
      set(customerSystemTypeState, value);
      set(customerEnabledState, value);
      set(customerReportEnabledState, value);
      set(customerSystemLinkState, value);
      return;
    }
    set(customerCodeState, value.code);
    set(customerSystemEmailState, value.systemEmail);
    set(customerNotesState, value.notes);
    set(customerNameState, value.name);
    set(customerWarrantyExpirationState, value.warrantyExpiration);
    set(customerServiceH24State, value.serviceH24);
    set(customerFormSavingState, value.saving);
    set(customerFormLoadingState, value.loading);
    set(customerFormErrorState, value.error);
    set(customerFunnelSystemCodeState, value.funnelSystemCode);
    set(customerFunnelEmailState, value.funnelEmail);
    set(customerSystemTypeState, value.systemType);
    set(customerEnabledState, value.enabled);
    set(customerReportEnabledState, value.reportEnabled);
    set(customerSystemLinkState, value.systemLink);
  },
});

export { customerFormState }